// extracted by mini-css-extract-plugin
export default {"formRenderSty":"address-form_formRenderSty__+GRsn","formSty":"address-form_formSty__DTnHU","buttons":"address-form_buttons__43Rjh"};